import { defineRecipe } from "@chakra-ui/react";

const buttonShared = {
  borderWidth: "sm",
  borderRadius: 12
};

const buttonSharedDisabled = {
  cursor: "not-allowed",
  opacity: "1"
};

const buttonFilled = {
  ...buttonShared,
  bg: "button.bg.filled",
  borderColor: "button.border.filled",
  color: "button.label.filled",
  _hover: {
    bg: "button.bg.filledHover",
    borderColor: "button.border.filledHover",
    color: "button.label.filled"
  },
  _disabled: {
    ...buttonSharedDisabled,
    bg: "button.bg.disabled",
    borderColor: "button.bg.disabled",
    color: "button.label.disabled"
  },
  _loading: {
    bg: "button.bg.filledHover",
    borderColor: "button.border.filledHover",
    color: "button.label.filled"
  }
};

const buttonHollow = {
  ...buttonShared,
  bg: "button.bg.hollow",
  borderColor: "button.border.hollow",
  color: "button.label.hollow",
  _hover: {
    bg: "button.bg.hollow",
    borderColor: "button.border.hollowHover",
    color: "button.label.hollowHover"
  },
  _disabled: {
    ...buttonSharedDisabled,
    bg: "button.bg.disabledHollow",
    color: "button.label.disabledHollow",
    borderColor: "button.border.disabledHollow"
  },
  _loading: {
    bg: "button.bg.hollow",
    borderColor: "button.border.hollowHover",
    color: "button.label.hollowHover"
  }
};

const primaryShared = {
  h: "58px",
  px: "23px",
  py: "22px",
  fontSize: "md",
  textStyle: "buttonLabel.large"
};

const secondaryShared = {
  h: "48px",
  px: "19px",
  py: "18px",
  fontSize: "sm",
  textStyle: "buttonLabel.standard"
};

const tertiaryShared = {
  h: "39px",
  px: "15px",
  py: "14px",
  fontSize: "xs",
  textStyle: "buttonLabel.small",
  borderRadius: 8
};

const iconShared = {
  bg: "transparent",
  borderColor: "transparent",
  borderRadius: "50%",
  px: 2,
  py: 2,
  minW: 0,
  h: "auto"
};

const buttonRecipe = defineRecipe({
  base: {
    fontFamily: "Inter, sans-serif",
    opacity: "1",
    borderWidth: "sm",
    borderRadius: 12,
    whiteSpace: "normal",
    wordWrap: "break-word",
    _loading: {
      opacity: "1"
    }
  },
  variants: {
    variant: {
      ghost: {
        border: "none"
      },
      outline: {
        bg: "white",
        borderColor: "black",
        border: "sm",
        fontWeight: "bold"
      },
      link: {
        border: "none",
        color: "button.label.link",
        _active: {
          color: "button.label.link"
        }
      },
      textLink: {
        border: "none",
        height: "auto",
        fontWeight: "normal",
        color: "button.label.hollow",
        fontSize: 14,
        textDecoration: "underline",
        fontFamily: "body",
        padding: 0,
        _hover: {
          textDecoration: "underline"
        },
        _disabled: {
          color: "button.label.disabled",
          _hover: {
            cursor: "not-allowed",
            textDecoration: "underline"
          }
        }
      },
      primary: {
        ...buttonFilled,
        ...primaryShared
      },
      primaryHollow: {
        ...buttonHollow,
        ...primaryShared
      },
      secondary: {
        ...buttonFilled,
        ...secondaryShared
      },
      secondaryHollow: {
        ...buttonHollow,
        ...secondaryShared
      },
      tertiary: {
        ...buttonFilled,
        ...tertiaryShared
      },
      tertiaryHollow: {
        ...buttonHollow,
        ...tertiaryShared
      },
      danger: {
        // TODO:: We have to change these varinat names when we are working on bark components
        bg: "danger.500",
        color: "white",
        fontWeight: "bold",
        _hover: {
          bg: "danger.600",
          color: "white"
        },
        _disabled: {
          bg: "danger.300"
        }
      },
      unstyled: {
        bg: "transparent",
        color: "legacy.royalBlue.500"
      },
      icon: {
        ...iconShared,
        _hover: {
          bg: "action.300",
          borderColor: "action.300"
        }
      },
      iconNoBg: {
        ...iconShared,
        border: "none",
        outline: "none",
        _hover: {
          bg: "transparent",
          border: "none",
          outline: "none"
        },
        _active: {
          bg: "transparent",
          border: "none",
          outline: "none"
        },
        _focus: {
          boxShadow: "none",
          outline: "none",
          border: "none"
        },
        _focusVisible: {
          boxShadow: "none",
          outline: "none",
          border: "none"
        },
        _after: {
          border: "none",
          outline: "none"
        },
        _before: {
          border: "none",
          outline: "none"
        }
      }
    },
    size: {
      sm: {
        fontSize: 13,
        w: "auto",
        py: 3.5,
        px: 8,
        h: 10
      },
      md: {
        fontSize: 16,
        w: "auto",
        py: 3.5,
        px: "2.4rem",
        h: 12
      }
    }
  },
  defaultVariants: {
    variant: "secondary",
    size: "md"
  }
});

export default buttonRecipe;
